import React, {useEffect, useState} from "react";
import './pagePayment.css'
import RecapPayment from "./recapPayment";
import { GiCheckMark } from "react-icons/gi";
import TopBarPayment from "./topBarPayment";
import { useSearchParams,useNavigate } from "react-router-dom";
import { CommandProps } from "../../components/types/types";

const PageSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [show,setShow] = useState(false)
    const [valueCommand,setValueCommand] = useState<CommandProps[]>([])
    useEffect(() => {

        const token = searchParams.get("token");
        const accesToken = searchParams.get("accesToken")
        if (!token) {
            navigate("/"); 
            return;
        }
        const validtoken = async () => {
            try {
                const result = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/verify_payment_token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({token: token}),
                });
        
                if (!result.ok) {
                    navigate("/"); 
                }
                
                const data = await result.json()
                if (!data.valid) {
                    navigate("/"); 
                } else {
                    const { command, ref, auto, erreur } = data.payload;
                    setValueCommand(command)

                    setShow(true)
                    if(accesToken) localStorage.setItem('token', accesToken);
                    const timer = setTimeout(() => {
                        window.location.href = '/restaurateurLogin';
                    }, 10000);
                    return () => clearTimeout(timer);
                }
            }
            catch {
               navigate("/"); 
        }}
        validtoken()

    }, [navigate, searchParams]);
   
    return(
        <div className="pageSuccess">      
            <TopBarPayment />
            {show && <>
                <div className="largeTitle">Paiement accepté ! <GiCheckMark size={30} color="#00E676"/> </div>   
                <RecapPayment  command={valueCommand} />

                <p className="smallText textExplain">Merci ! Votre paiement a bien été accepté.</p>
                <p className="smallText textExplain">Vous allez être redirigé vers votre tableau de bord.</p>

                <p className="smallText waitingText">Veuillez patienter quelques instants...</p>
           </>}
        </div>
    )
}


export default PageSuccess